module.exports = __webpack_public_path__ + "static/media/296280.02692553.png";